import { withI18n } from 'lingui-react';
import PropTypes from 'prop-types';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { compose, setDisplayName } from 'recompose';
import URL from 'url-parse';

import { A } from 'base-components';
import IconWrapper from 'elements/IconWrapper';

import { makeApiUrl } from 'utils/fetch';

import messages from './messages';

/**
 * The URLs for PDFs (for estimates, etc) provided by the API are potentially URLs that
 * will require an `access_token` to authorize access.  This component encapsulates the
 * logic for authorizing these URLs and also standardizes the formatting of a PDF link to
 * include the appropriate icon and formatting.
 *
 * @param url The URL for the PDF.  If not provided, an empty span will be returned.
 * @param children The text of the PDF link should be provided as children of the component.
 */
export function PdfLink({ i18n, url, children }) {
  if (!url) {
    return <span />;
  }

  const parsedUrl = new URL(url, true);
  const authorizedUrl = makeApiUrl(
    `${parsedUrl.origin}${parsedUrl.pathname}`,
    parsedUrl.query,
  );

  return (
    <A
      aria-label={i18n._(messages.pdfLink)}
      target="_blank"
      href={authorizedUrl}
      modifiers={['colorText']}
    >
      <IconWrapper>
        <FontAwesome name="file-pdf-o" />
      </IconWrapper>
      {children}
    </A>
  );
}

PdfLink.propTypes = {
  i18n: PropTypes.shape({
    _: PropTypes.func.isRequired,
  }).isRequired,
  url: PropTypes.string,
  children: PropTypes.node,
};

PdfLink.defaultProps = {
  url: null,
  children: null,
};

export default compose(
  setDisplayName('PdfLink'),
  withI18n(),
)(PdfLink);



// WEBPACK FOOTER //
// ./components/PdfLink/index.js